/** @format */

export default {
  getPractices(state) {
    return state.practices;
  },
  getMedicalLettersRequests(state) {
    return state.medicalLetterRequests;
  },
  getMedicalLetterRequest(state) {
    return state.medicalLetterRequest;
  },
  getMedicalLetterRequestQuestions(state) {
    return state.medicalLetterRequestQuestions;
  },
  getSignature(state) {
    return state.signature;
  },
  getDoctorsProfile(state) {
    return state.doctorsProfile;
  },
  getAlternativeDoctors(state) {
    return state.alternativeDoctor;
  },
  getDoctorProfile(state) {
    return state.doctorProfile;
  },
  getDoctor(state) {
    return state.doctor;
  },
  getEmailError(state) {
    return state.emailError;
  },
};
